type RequestConfigLike = {
    baseURL?: string;
    url?: string;
};

type RequestContext = {
    baseURL: string;
    path: string;
    resolvedUrl: string;
};

const FALLBACK_ORIGIN = "http://localhost";

const isAbsoluteUrl = (value: string): boolean => /^[a-z][a-z\d+.-]*:\/\//i.test(value);

const getBrowserOrigin = (): string => {
    if (typeof window !== "undefined" && window.location.origin) {
        return window.location.origin;
    }

    return FALLBACK_ORIGIN;
};

const resolveBaseUrl = (baseURL?: string): string => {
    if (!baseURL) {
        return getBrowserOrigin();
    }

    if (isAbsoluteUrl(baseURL)) {
        return baseURL;
    }

    return new URL(baseURL, getBrowserOrigin()).toString();
};

const combineUrlParts = (baseURL: string, path: string): string => {
    const normalizedBase = baseURL.replace(/\/+$/, "");
    const normalizedPath = path.replace(/^\/+/, "");

    if (!normalizedPath) {
        return normalizedBase;
    }

    return `${normalizedBase}/${normalizedPath}`;
};

export const getRequestContext = (config: RequestConfigLike): RequestContext => {
    const path = config.url ?? "";
    const baseURL = resolveBaseUrl(config.baseURL);

    if (!path) {
        return {
            baseURL,
            path,
            resolvedUrl: baseURL,
        };
    }

    if (isAbsoluteUrl(path)) {
        return {
            baseURL,
            path,
            resolvedUrl: path,
        };
    }

    return {
        baseURL,
        path,
        resolvedUrl: combineUrlParts(baseURL, path),
    };
};
